import PropTypes from 'prop-types';
import React from 'react';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import Typography from '@/design-system/atoms/Typography';

import styles from './PullQuote.module.scss';

const PullQuote = ({ quote, attribution, ...props }) => {
    return (
        <ContentContainer>
            <div className={styles[`pull-quote`]}>
                <Typography
                    content="“"
                    className={styles[`pull-quote__quote-icon`]}
                    variant={Typography.VARIANT.H0}
                    tag={Typography.TAG.SPAN}
                />
                <div className={styles[`pull-quote__content`]}>
                    <Typography
                        tag={Typography.TAG.BLOCKQUOTE}
                        variant={Typography.VARIANT.H5}
                        content={quote}
                        className={styles[`pull-quote__quote`]}
                        {...props}
                    />
                    {attribution && (
                        <Typography
                            tag={Typography.TAG.CITE}
                            variant={Typography.VARIANT.T2}
                            content={`- ${attribution}`}
                            className={styles[`pull-quote__attribution`]}
                        />
                    )}
                </div>
            </div>
        </ContentContainer>
    );
};

PullQuote.propTypes = {
    /**
     * Quote of the PullQuote
     */
    quote: PropTypes.string,
    /**
     * Author of the PullQuote
     */
    author: PropTypes.string,
};

export default PullQuote;
